// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patch, updateItem } from '@ngxs/store/operators';
import { PROGRESS_STATUSES } from 'symbols';
import { UpdateGpsLocationMaster } from '../../../gps-location/states/gps-location/gps-location.actions';
import { MastersService } from '../../services/masters.service';
import { GetAllMasters, GetMasters } from './masters.actions';
import { MASTERS_STATE_DEFAULT, MastersStateModel } from './masters.model';

@State({ name: 'Masters', defaults: MASTERS_STATE_DEFAULT })
@Injectable()
export class MastersState {

  constructor(private service: MastersService) {
  }

  @Selector()
  static currentMasters(state: MastersStateModel): MastersStateModel['currentMasters'] {
    return state.currentMasters;
  }

  @Selector()
  static allMasters(state: MastersStateModel): MastersStateModel['allMasters'] {
    return state.allMasters;
  }


  @Selector()
  static loadMastersStatus(state: MastersStateModel): MastersStateModel['loadMastersStatus'] {
    return state.loadMastersStatus;
  }


  @Action(GetMasters)
  getMasters(ctx: StateContext<MastersStateModel>, { searchText }: GetMasters): void {
    ctx.patchState({
      loadMastersStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getMasters(searchText).subscribe({
      next: (response) => {
        ctx.patchState({
          currentMasters: response.data,
          loadMastersStatus: PROGRESS_STATUSES.SUCCESS
        });
      },
      error: (error) => {
        ctx.patchState({
          loadMastersStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }

  @Action(GetAllMasters)
  getAllMasters(ctx: StateContext<MastersStateModel>): void {
    ctx.patchState({
      loadMastersStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.service.getMasters('', 200).subscribe({
      next: (response) => {
        ctx.patchState({
          allMasters: response.data,
          loadMastersStatus: PROGRESS_STATUSES.SUCCESS
        });
      },
      error: (error) => {
        ctx.patchState({
          loadMastersStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }


  @Action([UpdateGpsLocationMaster])
  updateGpsLocationMaster(ctx: StateContext<MastersStateModel>, { master }: UpdateGpsLocationMaster): void {

    ctx.setState(patch({
      currentMasters: updateItem((item => item.id === master.id), master),
      allMasters: updateItem((item => item.id === master.id), master)
    }));
  }
}


